import React from 'react'

import Header from './components/Header'

const Layout = ({ children }) => (
    <>
        <Header />
        <div id="main-page" className="col-section">
            {children}
        </div>
    </>
)

export default Layout
